// extracted by css-extract-rspack-plugin
export default {"sectionTitle":"xRDXEW5TFhAKd_1V","emptyState":"DPYkyAwLOb4YGYKr"};